"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingRecapData = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const hui_1 = require("@travelnest/hui");
const helpers_1 = require("../../../entities/pricing/helpers");
const react_1 = require("react");
const Wrapper = styled_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 12px;
	border: 1px solid ${hui_1.theme.colors.LM_NU50T};
	padding: 16px;
	border-radius: 16px;
	width: 100%;
`;
const HorizontalContainer = styled_1.default.div `
	display: flex;
	flex-direction: row;
  	justify-content: space-around;
	margin-bottom: 24px;
`;
const VerticalPictogramInfo = styled_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
`;
// We are using the old library of @emotion/styled that doesn't allow this destructring
// To update it we need to update merlin theme as well
// @ts-ignore
const HighlightedStatLabel = styled_1.default.span `
	${hui_1.theme.typography.IR90};
	color: ${hui_1.theme.colors.typography.label};
`;
// We are using the old library of @emotion/styled that doesn't allow this destructring
// To update it we need to update merlin theme as well
// @ts-ignore
const HighlightedPrimaryStatLabel = styled_1.default.span `
	${hui_1.theme.typography.IR130};
	font-weight: 700;
	color: ${hui_1.theme.colors.typography.heading};
`;
// We are using the old library of @emotion/styled that doesn't allow this destructring
// To update it we need to update merlin theme as well
// @ts-ignore
const HighlightedStatSecondaryLabel = styled_1.default.span `
	${hui_1.theme.typography.IR90};
`;
const VerticalSeparator = styled_1.default.div `
	width: 0.5px;
  	height: auto;
	background-color: ${hui_1.theme.colors.LM_NU50T};
`;
const VerticalContainer = styled_1.default.div `
	display: flex;
	flex-direction: column;
`;
const SecondaryStatWithIcon = styled_1.default.div `
	display: flex;
  	flex-direction: row;
  	align-items: center;
  	justify-content: space-between;
`;
const LeftSideRow = styled_1.default.div `
	display: flex;
  	flex-direction: row;
	align-items: center;
`;
const HorizontalSeparator = styled_1.default.div `
	width: 100%;
  	height: 0.5px;
	background-color: ${hui_1.theme.colors.LM_NU50T};
	margin: 12px 0;
`;
const StyledIcon = (0, styled_1.default)(hui_1.Icon) `
	margin-right: 6px;
`;
const SmartPricingRecapData = (props) => {
    if (!props.recapData)
        return (React.createElement("div", null));
    const [currencySymbol] = (0, react_1.useState)(props.currency ? helpers_1.CurrencyInfo[props.currency].symbol : '£');
    const formattedDate = (date) => {
        const parsedDate = new Date(date);
        return parsedDate.toLocaleString('default', { month: 'short' })
            + " \'"
            + parsedDate.toLocaleString('default', { year: '2-digit' });
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Wrapper, null,
            React.createElement(HorizontalContainer, null,
                React.createElement(VerticalPictogramInfo, null,
                    React.createElement(hui_1.Pictogram, { name: "smartPricingPeak", size: 64 }),
                    React.createElement("p", null,
                        React.createElement(HighlightedStatLabel, null, currencySymbol),
                        React.createElement(HighlightedPrimaryStatLabel, null, props.recapData.highest_price)),
                    React.createElement(HighlightedStatSecondaryLabel, null, "Peak")),
                React.createElement(VerticalSeparator, null),
                React.createElement(VerticalPictogramInfo, null,
                    React.createElement(hui_1.Pictogram, { name: "smartPricingAverage", size: 64 }),
                    React.createElement("p", null,
                        React.createElement(HighlightedStatLabel, null, currencySymbol),
                        React.createElement(HighlightedPrimaryStatLabel, null, props.recapData.average_price)),
                    React.createElement(HighlightedStatSecondaryLabel, null, "Average")),
                React.createElement(VerticalSeparator, null),
                React.createElement(VerticalPictogramInfo, null,
                    React.createElement(hui_1.Pictogram, { name: "smartPricingMinimum", size: 64 }),
                    React.createElement("p", null,
                        React.createElement(HighlightedStatLabel, null, currencySymbol),
                        React.createElement(HighlightedPrimaryStatLabel, null, props.recapData.lowest_price)),
                    React.createElement(HighlightedStatSecondaryLabel, null, "Minimum"))),
            React.createElement(VerticalContainer, null,
                React.createElement(SecondaryStatWithIcon, null,
                    React.createElement(LeftSideRow, null,
                        React.createElement(StyledIcon, { name: 'CalendarUp', color: hui_1.theme.colors.LM_NU70T }),
                        React.createElement("span", null, "Peak month")),
                    React.createElement("div", null,
                        React.createElement(HighlightedStatLabel, null, formattedDate(props.recapData.peak_month)))),
                React.createElement(HorizontalSeparator, null),
                React.createElement(SecondaryStatWithIcon, null,
                    React.createElement(LeftSideRow, null,
                        React.createElement(StyledIcon, { name: 'CalendarDown', color: hui_1.theme.colors.LM_NU70T }),
                        React.createElement("span", null, "Lowest month")),
                    React.createElement("div", null,
                        React.createElement(HighlightedStatLabel, null, formattedDate(props.recapData.lowest_month)))),
                React.createElement(HorizontalSeparator, null),
                React.createElement(SecondaryStatWithIcon, null,
                    React.createElement(LeftSideRow, null,
                        React.createElement(StyledIcon, { name: 'Calendar', color: hui_1.theme.colors.LM_NU70T }),
                        React.createElement("span", null, "Pricing until")),
                    React.createElement("div", null,
                        React.createElement(HighlightedStatLabel, null, formattedDate(props.recapData.pricing_until)))))));
};
exports.SmartPricingRecapData = SmartPricingRecapData;
//# sourceMappingURL=SmartPricingRecapData.js.map